import {isLoggedIn} from 'utils/auth'

export default (store, keycloak) => ({
  path: 'account-management',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./AccountManagement').default
      callback(null, component)
    }, 'AccountManagement')
  },
  keycloak
})



// WEBPACK FOOTER //
// ./src/routes/AccountManagement/index.js